const tags_pt = require('./tags.json')
export default tags_pt